import styled from "styled-components";
export const PortfolioWrap = styled.div`
  background-color: #ffffff;
`;
export const Container = styled.div`
  margin-top: 26px;
`;
